<app-header></app-header>
<main class="pages">
    <section class="gradient-light">
        <div class="container pt-lg-5">
            <div class="row align-items-center mob-column-reverse">
                <div class="col-md-6">
                    <h1 alt="mobile survey application" class="h1-title mt-3">Pre-designed survey templates on deck!</h1>
                    <p class="sub-text mt-2">Utilize your time resourcefully by choosing from our pre designed question templates curated for all industries and businesses. All you have to do is browse, pick up the suitable template and start collecting data right away.
                    </p>
                    <div class="mt-lg-5">
                        <!-- <button class="btn btn-md px-lg-5 text-uppercase btn-outline-success mr-lg-2 ">Sign Up</button>
                        <button class="btn btn-md px-lg-5 text-uppercase btn-success">Try Now</button> -->
                        <a title="" class="btn btn-lg btn-success px-4 text-uppercase  mr-lg-2" data-toggle="modal" data-target="#callBack" id="callback"> Request a Demo</a>
                    </div>
                </div>
                <div class="col-md-6 ">
                    <div class="page-banner-img">
                        <img class="img-fluid w-100 mt-2 mt-lg-0" alt="Survey Templates" src="assets/templates.svg">
                    </div>
                </div>
            </div>
        </div>
    </section>



    <!-- Industries Grid -->
    <section class="mt-5 d-none">
        <div class="industries py-lg-5">
            <div class="container">
                <div class="row">
                    <div class="col-lg-4 mb-lg-4">
                        <div class="card" routerLink="/templates-details" routerLinkActive="active">
                            <img class="card-img-top" src="assets/healthcare.svg" alt="Healthcare Survey">
                            <div class="card-body">
                                <h5 class="card-title">HEALTHCARE</h5>
                                <p class="card-text">For maintaining harmony within the hospital, it's equally vital to know both patient experience and employee experience.</p>
                                <a routerLink="/templates-details" routerLinkActive="active" class="btn btn-secondary px-4">View More </a>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 mb-lg-4">
                        <div class="card" routerLink="/templates-details" routerLinkActive="active">
                            <img class="card-img-top" src="assets/education.svg" alt="Education Survey">
                            <div class="card-body">
                                <h5 class="card-title">EDUCATION</h5>
                                <p class="card-text">The educational survey helps you improve the environment of your institution, school or university by gathering feedback from both the students and lecturers and analysing it. </p>
                                <a href="education" class="btn btn-secondary px-4">View More</a>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 mb-lg-4">
                        <div class="card" routerLink="/templates-details" routerLinkActive="active">
                            <img class="card-img-top" src="assets/it&ites.svg" alt="IT Survey">
                            <div class="card-body">
                                <h5 class="card-title">IT & ITES</h5>
                                <p class="card-text">IT and Banking surveys provide you with the data assessed with the satisfaction of the respective customers, gathering feedback on products (IT) or services (Bank and IT); measure the attitude of new trends, etc. </p>
                                <a href="it-banking" class="btn btn-secondary px-4">View More</a>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="card" routerLink="/templates-details" routerLinkActive="active">
                            <img class="card-img-top" src="assets/hotel-and-restaurent.svg" alt="Hotel and Restaurant Survey">
                            <div class="card-body">
                                <h5 class="card-title">HOTEL & RESTAURANTS</h5>
                                <p class="card-text">Hotel and Restaurants surveys are broadly used by organizations that are engaged with lodging, cruise lines, resorts, food, drinks, theme parks, and more. </p>
                                <a href="hotel-restaurent" class="btn btn-secondary px-4">View More</a>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="card" routerLink="/templates-details" routerLinkActive="active">
                            <img class="card-img-top" src="assets/event-and-entertainment.svg" alt="Event and Entertainment Survey">
                            <div class="card-body">
                                <h5 class="card-title">EVENT & ENTERTAINMENT</h5>
                                <p class="card-text">Kick-start your event planning by getting the detail of every audience attending the event. The only way to have a successful event is to know about the crowd who attend the event and work accordingly. </p>
                                <a href="event-entertainment" class="btn btn-secondary px-4">View More</a>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="card" routerLink="/templates-details" routerLinkActive="active">
                            <img class="card-img-top" src="assets/market-research-2.svg" alt="Market Research Survey">
                            <div class="card-body">
                                <h5 class="card-title text-uppercase">Retail & Manufacturing</h5>
                                <p class="card-text">Market research survey is all about gathering systematic information regarding target markets and their customers. Nowadays market research surveys are easy to conduct as many online surveys are aiding.</p>
                                <a routerLink="/retail-manufacturing" class="btn btn-secondary px-4">View More</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- End Industries grid -->

    <!-- Templates Grid -->
    <section class="mt-lg-5">
        <div class="py-lg-5">
            <div class="container">
                <div class="row">
                    <div class="col-md-3 mb-3 mb-lg-0">
                        <div class="sidebox-aside-menu sticky-section">
                            <div class="card">
                                <div class="card-header">
                                    <div class="header-heading">Industries Templates</div>
                                </div>
                                <div class="card-body p-0">
                                    <div class="aside-vertical-tabs nav flex-column nav-pills" role="tablist">
                                        <a class="nav-link" data-toggle="pill" *ngFor="let lists of categorylist" role="tab" aria-controls="v-pills-home" aria-selected="true" (click)="tempList(lists.id,lists.category_name)">{{lists.category_name}}</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-9">
                        <div class="tab-content">
                            <div class="tab-pane fade show active" id="temp-healthcare" role="tabpanel" aria-labelledby="v-pills-home-tab">
                                <div class="row">
                                    <div class="col-lg-4 mb-lg-4 mb-3" *ngFor="let template of tempData">
                                        <!-- <div class="card survey-template-card"  *ngIf="Displaycategory_data.templates?.length > 0"  routerLink="/templates-question-details/{{ template.id}}" > -->
                                        <div class="card survey-template-card" (click)="templates_question(template.id,template.category_id)">
                                            <img class="card-img-top" src="{{server}}{{template?.file_select}}" alt="Survey App Templates">
                                            <div class="survey-template-card-overlay">
                                                <div class="card-body survey-template-card-body">
                                                    <h5 class="survey-template-card-title">{{template?.template_title}}</h5>
                                                    <div class="survey-template-card-details">
                                                        <p class="survey-template-card-subtitle" *ngFor="let list of tempcont">
                                                            <span *ngIf="template?.template_title == list.template_title">{{list.question_count}} Questions</span>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- <div class="tab-pane fade" id="temp-education" role="tabpanel" aria-labelledby="v-pills-profile-tab">
                                <div class="row">
                                    <div class="col-lg-4 mb-lg-4">
                                        <div class="card survey-template-card" routerLink="/templates-question-details">
                                            <img class="card-img-top" src="assets/templates/education.jpg" alt="Education Survey">
                                            <div class="survey-template-card-overlay">
                                                <div class="card-body survey-template-card-body">
                                                    <h5 class="survey-template-card-title">Student Feedback Survey Template</h5>
                                                    <div class="survey-template-card-details">
                                                        <p class="survey-template-card-subtitle">9 Question</p>
                                                    </div>
                                                </div>


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="tab-pane fade" id="ite-ites" role="tabpanel" aria-labelledby="v-pills-profile-tab">
                                <div class="row">
                                    <div class="col-lg-4 mb-lg-4">
                                        <div class="card survey-template-card" routerLink="/templates-question-details">
                                            <img class="card-img-top" src="assets/templates/itites.jpg" alt="IT Survey">
                                            <div class="survey-template-card-overlay">
                                                <div class="card-body survey-template-card-body">
                                                    <h5 class="survey-template-card-title">Customer Demographics Survey Template Customer Demographics Survey Template Customer Demographics Survey Template</h5>
                                                    <div class="survey-template-card-details">
                                                        <p class="survey-template-card-subtitle">9 Question</p>
                                                    </div>
                                                </div>


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="tab-pane fade" id="temp-hotel-restaurent" role="tabpanel" aria-labelledby="v-pills-profile-tab">
                                <div class="row">
                                    <div class="col-lg-4 mb-lg-4">
                                        <div class="card survey-template-card" routerLink="/templates-question-details">
                                            <img class="card-img-top" src="assets/templates/hote-restaurent.jpg" alt="Hotel Survey">
                                            <div class="survey-template-card-overlay">
                                                <div class="card-body survey-template-card-body">
                                                    <h5 class="survey-template-card-title">Restaurant Feedback Form Template</h5>
                                                    <div class="survey-template-card-details">
                                                        <p class="survey-template-card-subtitle">9 Question</p>
                                                    </div>
                                                </div>


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="tab-pane fade" id="event-entertainment" role="tabpanel" aria-labelledby="v-pills-profile-tab">
                                <div class="row">
                                    <div class="col-lg-4 mb-lg-4">
                                        <div class="card survey-template-card" routerLink="/templates-question-details">
                                            <img class="card-img-top" src="assets/templates/event-entertainment.jpg" alt="Event Survey">
                                            <div class="survey-template-card-overlay">
                                                <div class="card-body survey-template-card-body">
                                                    <h5 class="survey-template-card-title">Post Event Survey Template</h5>
                                                    <div class="survey-template-card-details">
                                                        <p class="survey-template-card-subtitle">9 Question</p>
                                                    </div>
                                                </div>


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="tab-pane fade" id="retail-manufacturing" role="tabpanel" aria-labelledby="v-pills-profile-tab">
                                <div class="row">
                                    <div class="col-lg-4 mb-lg-4">
                                        <div class="card survey-template-card" routerLink="/templates-question-details">
                                            <img class="card-img-top" src="assets/templates/retail-store-evaluation.jpg" alt="Retail Survey">
                                            <div class="survey-template-card-overlay">
                                                <div class="card-body survey-template-card-body">
                                                    <h5 class="survey-template-card-title">Retail Store Evaluation Survey Template</h5>
                                                    <div class="survey-template-card-details">
                                                        <p class="survey-template-card-subtitle">9 Question</p>
                                                    </div>
                                                </div>


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- End Templates Grid -->

</main>
<app-footer></app-footer>